import React, { useEffect, useRef } from "react"
import { H1, P } from "../../Partials/Typography"
import { HeroSection, HeroRightContainer } from "../../Partials/Hero.jsx"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import VerticalSpacer from "../../Partials/VerticalSpacer.jsx"
import ReactHtmlParser from "react-html-parser"
import { fontSize } from "../../../styles/fonts/fontStyle"
import { spacer } from "../../../styles/sizes"
import AppContainer from "../../../styles/AppContainer"
import { ParagraphsContainer } from "./ParagraphsContainer"
import { deviceMinW } from "../../../styles/mediaQueries"

const Introduction = ({
    heading = {},
    logo,
    video,
    fontColor,
    introductionCopy = []
}) => {
    const videoEl = useRef(null)

    const attemptPlay = () => {
        videoEl &&
            videoEl.current &&
            videoEl.current.play().catch(error => {
                console.error("Error attempting to play", error)
            })
    }

    useEffect(() => {
        attemptPlay()
    }, [])

    return (
        <>
            <AppContainer>
                <HeroSection
                    css={css`
                        padding-bottom: 10rem;
                    `}
                >
                    <HeroRightContainer>
                        <ClientLogoContainer>
                            <ClientLogo src={logo.src.publicURL} />
                        </ClientLogoContainer>
                        <VerticalSpacer size="m" />
                        <CaseStudyH1 fontColor={fontColor}>
                            {ReactHtmlParser(heading.title)}
                        </CaseStudyH1>
                        <VerticalSpacer size="xl" />
                        <CaseStudyVideo
                            autoload={true}
                            autoPlay={true}
                            loop={true}
                            muted={true}
                            playsInline={true}
                            alt={video.alt}
                            ref={videoEl}
                            src={video.src}
                            poster={video.poster}
                        />
                        <VerticalSpacer size="xl" />
                        <Credits fontColor={fontColor}>
                            {ReactHtmlParser(heading.agencyStatement)}
                        </Credits>
                        <VerticalSpacer size="xl" />
                        <ParagraphsContainer>
                            {introductionCopy.map(({ id, paragraph }) => (
                                <IntroductionP key={id} fontColor={fontColor}>
                                    {ReactHtmlParser(paragraph)}
                                </IntroductionP>
                            ))}
                        </ParagraphsContainer>
                    </HeroRightContainer>
                </HeroSection>
            </AppContainer>
        </>
    )
}
export default Introduction

const ClientLogoContainer = styled.div`
    height: 3rem;
    position: relative;
`

const ClientLogo = styled.img`
    max-height: 100%;
    max-width: 100%;
`
const CaseStudyVideo = styled.video`
    width: 100%;
`

const CaseStudyH1 = styled(H1)`
    color: ${props => props.fontColor};

    sup {
    font-size: ${fontSize.bodyCopy};
    position: relative;
    vertical-align: super;
    top: -10px;
}
    }
`
const IntroductionP = styled(P)`
    color: ${props => props.fontColor};
    font-size: ${fontSize.bodyCopy};
    max-width: 65ch;
    padding-bottom: ${spacer.l};
    font-weight: 500;

    @media ${deviceMinW.tablet} {
        font-size: ${fontSize.doublePica};
        max-width: 45ch;
    }

    &:last-of-type {
        padding-bottom: 0;
    }
`
const Credits = styled.p`
    display: flex;
    flex-direction: column;
    color: ${props => props.fontColor};
    font-size: ${fontSize.brevier};
    font-style: italic;
    max-width: 75ch;
`
